import React from "react";
import { Row, Col, Button } from "antd";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";

import CurrentSkincareComponent from "./sections/currentSkincare";
import ReviseSkincareComponent from "./sections/reviseSkincare";
import SkinProfileComponent from "./sections/skinProfile";
import Greetings from "./sections/greetings";
import _ from "lodash";

interface DashboardComponentInterface {
  data?: any;
  currentSkincare?: any;
}

const DashboardComponent: React.FC<DashboardComponentInterface> = (props) => {
  const { data, currentSkincare } = props;
  const navigate = useNavigate();

  const currMorningProducts = _.filter(currentSkincare?.morning, [
    "user_product",
    true,
  ]);

  const currNightProducts = _.filter(currentSkincare?.night, [
    "user_product",
    true,
  ]);

  const currentSkincareProducts = _.concat(
    currMorningProducts,
    currNightProducts
  );

  const dontUseProducts = _.filter(currentSkincareProducts, ["dont_use", true]);
  const keepUsingProducts = _.filter(currentSkincareProducts, [
    "dont_use",
    false,
  ]);

  const uniDontUseProducts = _.reduce(
    dontUseProducts,
    (res: any, row: any) => {
      let el = _.find(res, (el: any) => {
        return (
          // el["category_id"] === row["category_id"] &&
          el["brand_name"].toLowerCase() === row["brand_name"].toLowerCase() &&
          el["name"].toLowerCase() === row["name"].toLowerCase()
        );
      });

      if (el) {
        el["note"] = [el["note"], row["note"]];
      } else {
        res.push({ ...row });
      }
      return res;
    },
    []
  );

  const uniKeepUsingProducts = _.reduce(
    keepUsingProducts,
    (res: any, row: any) => {
      let el = _.find(res, (el: any) => {
        return (
          // el["category_id"] === row["category_id"] &&
          el["brand_name"].toLowerCase() === row["brand_name"].toLowerCase() &&
          el["name"].toLowerCase() === row["name"].toLowerCase()
        );
      });

      if (el) {
        el["note"] = [el["note"], row["note"]];
      } else {
        res.push({ ...row });
      }
      return res;
    },
    []
  );

  return (
    <>
      <div className="skin-profile">
        <Row gutter={30}>
          <Col span={12} xs={24} sm={24} md={24} lg={12}>
            <Greetings data={data?.response} />
          </Col>
          <Col span={12} xs={24} sm={24} md={24} lg={12}>
            <SkinProfileComponent data={data?.skin_profile} />
            <ReviseSkincareComponent />
          </Col>
        </Row>
        {/* 
        {uniKeepUsingProducts.length > 0 || uniDontUseProducts.length > 0 ? (
          <CurrentSkincareComponent
            keepUsing={uniKeepUsingProducts}
            dontUse={uniDontUseProducts}
          />
        ) : null} */}
      </div>
      <div className="footer-cta">
        <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/how-to-use");
            ReactGA.event({
              category: "Store",
              action: `Go to Skincare Steps button clicked`,
              label: "",
              nonInteraction: true, // optional, true/false
              transport: "xhr",
            });
          }}
        >
         Go to How To Use
        </Button>
      </div>
    </>
  );
};

export default DashboardComponent;
